var React = require('react');

function IconFillArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M7 14l5-5 5 5z","transform":"translate(-7 -9)"}));
}

IconFillArrowUp.defaultProps = {"width":"10","height":"5","viewBox":"0 0 10 5"};

module.exports = IconFillArrowUp;

IconFillArrowUp.default = IconFillArrowUp;
